import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ConfirmModal from "@/widgets/ConfirmModal";

export default function SessionExpiryGate() {
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [to, setTo] = useState("/login");
  useEffect(() => {
    const h = e => { setTo(e?.detail?.loginPath || "/login"); setOpen(true); };
    window.addEventListener("app:session-expired", h);
    return () => window.removeEventListener("app:session-expired", h);
  }, []);
  if (!open) return null;
  return (
    <ConfirmModal
      type="alert"
      title="แจ้งเตือน"
      message="เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่"
      onClose={() => { setOpen(false); window.location.href = to; }}
    />
  );
}
